document.addEventListener('DOMContentLoaded', () => {
    // Masonry Layout
    const grid = document.querySelector('.blog-articles');
    if (grid && !grid.classList.contains('blog-articles_grid')) {
        var msnry = new Masonry(grid, {
        itemSelector: '.blog-articles__article',
        horizontalOrder: true,
        gutter: 30
        });
    }
    //Slide
    const swiper = new Swiper('.swiper-container', {
        slidesPerView: 1.1,
        centeredSlides: false,
        spaceBetween: 26,
        loop: false,
        allowTouchMove: true,
        pagination: {
        el: '.swiper-pagination',
        clickable: true,
        },
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
        320: {
            slidesPerView: 1.5,
            spaceBetween: 15,
        },
        767: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        },
    });

    //Height Cart Content
    const card_contents = document.querySelectorAll('.featured-posts .article-card-wrapper .article-card > .card__content');
    let maxHeight = 0;
    card_contents.forEach(div => {
        const height = div.getBoundingClientRect().height;
        if (height > maxHeight) {
            maxHeight = height; 
        }
    });
    card_contents.forEach(div => {
        div.style.height = `${maxHeight}px`;
    });

    // Blog Load more
    const loadMoreBtn = document.querySelector('.main-blog .see-more-button');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const blogGrid = document.querySelector('.main-blog .blog-articles');
        const nextUrl = loadMoreBtn.getAttribute('href');
        if (!nextUrl) return;

        loadMoreBtn.innerText = "Loading...";
        loadMoreBtn.classList.add("loading");

        fetch(nextUrl)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const newArticles = doc.querySelectorAll(".main-blog .blog-articles .blog-articles__article");
            newArticles.forEach(article => blogGrid.appendChild(article));
            msnry.appended(newArticles)

            const newLoadMore = doc.querySelector(".main-blog .see-more-button");
            if (newLoadMore) {
              loadMoreBtn.setAttribute("href", newLoadMore.getAttribute("href"));
              loadMoreBtn.innerText = newLoadMore.getAttribute('data-text');
              loadMoreBtn.classList.remove("loading");
            } else {
              loadMoreBtn.remove();
            }
           
          })
          .finally(() => {})
          .catch(err => {
            console.error(err);
            loadMoreBtn.remove();
          });
      })
    }
});
window.addEventListener('hashchange', function() {
    const hash = window.location.hash.replace('#', '');
    filterBlogs(hash || 'all');
});